import { format, isValid, parse } from "date-fns";
import {
  DATE_MONTH_YEAR_FORMAT,
  YEAR_MONTH_DAY_FORMAT,
} from "../DateTime.constants";

export const convertStringToDateObject = ({
  dateString,
  format: dateFormat = YEAR_MONTH_DAY_FORMAT,
}) => parse(dateString, dateFormat, new Date());

/**
 * Normalizes API / record date values to dd-MM-yyyy for booking expiry updates.
 */
export const formatAsDateMonthYear = (dateValue) => {
  if (!dateValue) return "";

  let date = dateValue instanceof Date && isValid(dateValue) ? dateValue : null;

  if (!date) {
    const ymdParsed = parse(
      String(dateValue),
      YEAR_MONTH_DAY_FORMAT,
      new Date()
    );
    if (isValid(ymdParsed)) date = ymdParsed;
  }

  if (!date) {
    const dmyParsed = parse(
      String(dateValue),
      DATE_MONTH_YEAR_FORMAT,
      new Date()
    );
    if (isValid(dmyParsed)) date = dmyParsed;
  }

  if (!date) {
    const fallback = new Date(dateValue);
    if (isValid(fallback)) date = fallback;
  }

  return date ? format(date, DATE_MONTH_YEAR_FORMAT) : "";
};

/** Converts dd-MM-yyyy expiry string to yyyy-MM-dd for API payloads. */
export const formatExpiryForApi = (dateValue) => {
  const normalized = formatAsDateMonthYear(dateValue);
  if (!normalized) return "";
  const parsed = parse(normalized, DATE_MONTH_YEAR_FORMAT, new Date());
  return isValid(parsed) ? format(parsed, YEAR_MONTH_DAY_FORMAT) : "";
};

/**
 * Converts a day interval (0-6) to the corresponding day name, where 0 is Monday.
 *
 * @param {number} interval - The day interval (0 for Monday, 1 for Tuesday, ..., 6 for Sunday).
 * @returns {string} - The name of the day (e.g., "Monday", "Tuesday").
 */
export const getDayFromInterval = (interval) => {
  const dayNames = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  interval = parseInt(interval ?? 0);

  if (interval < 0 || interval > 6 || typeof interval !== "number") {
    return interval;
  }
  return dayNames[interval];
};
